export default {
	home: {
		welcome: 'Bem-vindos'
	}
};
